module.exports = __webpack_public_path__ + "media/customizations/serenbe/back-4c249185a9e7cc4ed284693bb7b1aa73.jpg";